// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewTooltip_wrapper__34FYv","flex":"NewTooltip_flex__YIq8j","box":"NewTooltip_box__1cBT2"};